import { jwtDecode } from "jwt-decode";

/**
 * Return data from the token
 */

export const tokenParams = () => {
	const token = localStorage.getItem("Session");

	if (!token) return null;
	const decoded = jwtDecode(token);

	// Dev-only permission override, set via the floating DEV settings button.
	if (process.env.NODE_ENV === "development") {
		const override = JSON.parse(
			localStorage.getItem("DevPermissionOverride") || "null"
		);
		if (override) {
			return {
				...decoded,
				...(override.isBimifyAdmin != null && {
					isBimifyAdmin: override.isBimifyAdmin,
				}),
				...(override.roleType && {
					role: { ...decoded.role, type: override.roleType },
				}),
			};
		}
	}
	return decoded;
};

/**
 * Return logged user token
 */
export const getToken = () => localStorage.getItem("Session");

/**
 * Return user permissions
 */
export const getPermissions = () =>
	!!localStorage.getItem("Permissions")
		? JSON.parse(localStorage.getItem("Permissions")) || null
		: null;

/**
 * Return global customer
 */
export const getCustomer = () => localStorage.getItem("Customer");

/**
 * Return global reseller
 */
export const getReseller = () => localStorage.getItem("Reseller");

export const setItemToLocalStorage = (name, value) =>
	localStorage.setItem(name, value);

export const removeItemFromLocalStorage = (name) =>
	localStorage.removeItem(name);

export const getItemFromLocalStorage = (name) => localStorage.getItem(name);

export const setItemToSessionStorage = (name, value) =>
	sessionStorage.setItem(name, value);

export const removeItemFromSessionStorage = (name) =>
	sessionStorage.removeItem(name);

export const getItemFromSessionStorage = (name) => sessionStorage.getItem(name);

export const isLogin = () => {
	if (getItemFromLocalStorage("Session")) return true;
	return false;
};
